/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Marquee from "react-fast-marquee";
import { playSong, setBodyEvents, setEvents, setMixEvents } from '../../common/actions/common.actions';
import { GiRunningShoe } from "react-icons/gi";
import { LuNewspaper } from "react-icons/lu";
import { PiArrowLineUpRightBold } from "react-icons/pi";
import dashboardService from "../../../api/services/dashboardService";
import withAuth from "../../common/hoc/withAuth";
import SideBarToggle from "../../common/components/sidebar/SideBarToggle";
import Logo from "../../common/components/Logo";
import PopupModal from './popupModal';
import { useTranslation } from "react-i18next";
import DarkThemeToggleComponent from "../../../darkThemeToggle";
import { BiFootball } from "react-icons/bi";
import { setConfirmData } from '../../common/actions/common.actions';
import { selectLoginData } from "../login/login.actions";
import { IoCheckmarkDoneSharp, IoWallet } from "react-icons/io5";
import signalRConnection from '../../../signalR/signalRService';
import { MdSportsScore } from "react-icons/md";
import Loader from './component/spinner';

function Dashboard({ setShowSideBar, setIsLoading }) {
  const dispatch = useDispatch();
  const [displayTextArr, setDisplayTextArr] = useState([]);
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userDetails } = useSelector(selectLoginData);
  const [userBalance, setUserBalance] = useState(userDetails?.balance);
  const navigate = useNavigate();

  useEffect(() => {
    const handleChangedBalance = async (user, data) => {
      console.log(`changedBalance Event: ${user}: ${data}`);
      // Handle process after changedBalance
      const userDetailTmp = userDetails || {};
      await updateUserBalance(userDetailTmp);
    };
    signalRConnection.on("changedBalance", handleChangedBalance);
    // Cleanup the event handler when the component unmounts
    return () => {
      signalRConnection.off("changedBalance", handleChangedBalance);
    };
  }, [signalRConnection, userDetails]);
  
  // add akn for click song
  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleConfirmData = (data) => {
    dispatch(setConfirmData(data));
  };

  const handlePopupToggle = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const removeConfirmData = () => {
    handleConfirmData(null);
  };

  const initData = async () => {
    try {
      // setIsLoading(true);
      await removeConfirmData();
      // const userDetailTmp =
      //   (await JSON.parse(localStorage.getItem("userDetails"))) || {};
      const userDetailTmp = userDetails || {};
      const getDisplayEvents = async () => {
        const data = await dashboardService.getDisplayTextForDashboard().json();
        setDisplayTextArr(data);
      };
      await getDisplayEvents();
      await updateUserBalance(userDetailTmp);
    } catch (error) {
      console.log({ error });
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    initData();
    dispatch(setMixEvents([]));
    dispatch(setBodyEvents([]));
    dispatch(setEvents([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails && storedUserDetails?.balance) {
      setUserBalance(storedUserDetails?.balance);
    }
  }, []);

  const updateUserBalance = async (userDetailTmp) => {
    if (!userDetailTmp.userId) return;
    try {
      const userId = Number(userDetailTmp.userId);
      const res = await dashboardService.getBalanceForDashboard(userId)
        .then((response) => response.json());
      if (res) {
        if (res && res.userInfo) {
          setUserBalance(res?.userInfo[0]?.balance);
          localStorage.setItem("userDetails", JSON.stringify(res?.userInfo[0]));
        }
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  };

  return (
    <div className="flex flex-row w-full h-[100dvh] bg-transparent dark:bg-background">
      <SideBarToggle setShowSideBar={setShowSideBar} />
      <div className="z-40 absolute cursor-pointer top-16 left-8 mt-2">
        <DarkThemeToggleComponent />
      </div>
      {/* <Popup data={displayTextArr} /> */}
      <PopupModal data={displayTextArr} isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen}/>
        <div className="flex flex-col justify-center items-center h-full w-full md:w-[60vw] lg:w-[30vw] mx-auto px-10 sm:px-4">
        <Logo />
        <div data-modal-target="popup-modal" data-modal-toggle="popup-modal" className="w-full h-8 cursor-pointer z-40 md:w-full flex justify-center  text-center mt-3 mb-1 px-2 py-1"
          onClick={handlePopupToggle}
        >
          <div className="w-full align-middle justify-center text-left overflow-hidden" dir="ltr">
            <div className="w-full font-bold text-black drop-shadow-md dark:text-white whitespace-nowrap">
              {/* <div id="scroll-text" className="overflow-hidden">
                {displayTextArr.map(d => d.displayText).join(' ')}
              </div> */}
              <Marquee>
                {displayTextArr.map(d => d.displayText).join(' ')}
              </Marquee>
            </div>
          </div>
        </div>

        <div className="z-40 w-full font-myanmarSansPro px-1" data-aos="fade-down">
          <div
            className="w-full h-[10vh] flex bg-dashboard border border-slate-700 justify-between items-center rounded-lg text-white px-5 md:px-10 "
          >
            <div className="flex items-center ml-2">
              {/* <img src={scan} alt='scan'></img> */}
              <IoWallet size={28} />
              {/* <AiOutlineScan size={28} /> */}
            </div>
            <div className="font-inter font-bold text-lg">{parseInt(userBalance).toLocaleString()} Ks</div>  {/* text-sm xs:text-base */}
            <div className="w-7 h-7" aria-hidden="true" />
          </div>
        </div>


        <div className="flex py-2 w-full px-1">
          <div className="flex flex-col flex-grow">

            <div className="z-40 w-full" data-aos="fade-up">
              <div className="h-[10vh] cursor-pointer flex bg-dashboard border border-slate-700 justify-center items-center rounded-lg text-white mb-2 px-5 md:px-10"
                onClick={(e) => {
                  handleSongClick().then(() => {
                    navigate('/maungg');
                  });
                }}
              >
                <GiRunningShoe size={26} className="mr-5" />
                {/* <GiRunningShoe size={26} className="mr-5" /> */}
                <div className="text-sm xs:text-base">{t("maungg")}</div>
              </div>
            </div>
            <div className="z-40 w-full" data-aos="fade-right">
              <div className="h-[10vh] flex cursor-pointer bg-dashboard border border-slate-700 justify-center items-center rounded-lg text-white px-5 md:px-10"
                onClick={(e) => {
                  handleSongClick().then(() => {
                    navigate('/body');
                  });
                }}
              >
                <BiFootball size={26} className="text-white mr-5" />
                <div className="text-center text-sm xs:text-base">{t("body")}<br />{t("totalGoals")}</div>
              </div>
            </div>
          </div>

          <div className="flex flex-1 flex-shrink" data-aos="fade-left">
            <div className="z-40 w-full" to={'/gift'} data-aos="fade-left">
              <div className="h-full cursor-pointer flex flex-col bg-dashboard border border-slate-700 justify-center text-center items-center rounded-lg text-white sm:px-5 px-0 ml-2"
              onClick={(e) => {
                handleSongClick().then(() => {
                  navigate('/highlight');
                });
              }}
              >
                <div className="w-20 h-24">
                  <Loader />
                </div>
                {/* <div className="flex">
                  <span className="text-[#00fd2a] text-xs mt-4">High</span>
                  <span className="text-[#ffffff] text-xs mt-4">light</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full px-1">
          <div className="flex flex-1 flex-shrink" data-aos="fade-up-right">
            <div className="z-40 w-full">
              <div className="h-full cursor-pointer flex flex-col bg-dashboard border border-slate-700 justify-center text-center items-center rounded-lg text-white sm:px-5 px-0 mr-2"
                onClick={(e) => {
                  handleSongClick().then(() => {
                    navigate('/rules');
                  });
                }}
              >
                <LuNewspaper size={26} />
                {/* <LuNewspaper size={26} /> */}
                <div className="text-white text-sm xs:text-base bg-clip-text bg-gradient-to-r mt-8 mb-4 transform -rotate-90 whitespace-nowrap">{t("rule")}</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col flex-grow">
            <div className="z-40 w-full" data-aos="fade-up-left">
              <div className="h-[10vh] flex cursor-pointer bg-dashboard border border-slate-700 justify-center items-center rounded-lg text-white mb-2 sm:px-5 px-0 md:px-10"
                onClick={(e) => {
                  handleSongClick().then(() => {
                    navigate('/selected-matches');
                  });
                }}
              >
                <PiArrowLineUpRightBold size={26} className="mr-5" />
                {/* <PiArrowLineUpRightBold size={26} className="mr-5" /> */}
                <div className="text-center text-sm xs:text-base">{t("selected")}<br />{t("matches")}</div>
              </div>
            </div>
            <div className="z-40 w-full" data-aos="fade-down-right">
              <div className="h-[10vh] cursor-pointer flex bg-dashboard border border-slate-700 justify-center items-center rounded-lg text-white xs:px-10 px-0 md:px-10"
                onClick={(e) => {
                  handleSongClick().then(() => {
                    navigate('/old-histories');
                  });
                }}
              >
                <div>
                  {/* <img className="mr-5" src={right} alt='right'></img> */}
                  <IoCheckmarkDoneSharp size={26} className="mr-1" />
                </div>
                <div className="text-center text-sm xs:text-base">{t("oldHistories")}</div>
              </div>
            </div>

          </div>
        </div>

        <div className="w-full flex py-2 px-1">
          <Link className="z-40 w-full">
            <div className="h-[10vh] cursor-pointer flex flex-grow bg-dashboard border border-slate-700 justify-center items-center rounded-lg text-white mr-2 px-5 md:px-10 sm:px-5"
              onClick={(e) => {
                handleSongClick().then(() => {
                  navigate('/goal-score');
                });
              }}
            >
              <MdSportsScore size={26} className="mr-3" />
              {/* <GiSoccerKick size={26} className="mr-5" /> */}
              <div className="">{t("goalResult")}</div>
            </div>
          </Link>
          <div className="z-40 w-full" to={'/account'}>
            <div className="h-[10vh] cursor-pointer flex flex-shrink gap-2 bg-dashboard border border-slate-700 justify-center text-center items-center rounded-lg text-white"
              onClick={(e) => {
                handleSongClick().then(() => {
                  navigate('/account');
                });
              }}
            >
              {/* <img src={forwardArrow} alt='forward'></img> */}
              <IoWallet size={26} />
              <div className="">{t("statement")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withAuth(Dashboard);
